import styled from 'styled-components';
import React from "react";

const PartnerWrapper = styled.div`
  display: flex;
  @media only screen and (max-width: 700px) {
    flex-direction: column;
  }
`;

const Half = styled.div`
  width: 50%;
  padding: 40px;
  text-align: center;
  @media only screen and (max-width: 700px) {
    width: 100%
  }
`;

export default () => (
  <PartnerWrapper>
    <Half>
      <h5>Ganesh Ventures</h5>
      <p style={{fontSize:'15px',color:'#667988',fontWeight:'300',letterSpacing:'1.1px'}}>Backed by Chinese ecommerce giant Alibaba Group, Ganesh Ventures is a India-focussed fund. They have invested about $30 million in several Indian startups including Zoomcar, Indialends, KrazyBee, HappyEasyGo and BeYouPlus to name a few.</p>
    </Half>
    <Half>
      <h5>M&S Partners</h5>
      <p style={{fontSize:'15px',color:'#667988',fontWeight:'300',letterSpacing:'1.1px'}}>M&S Partners, is a venture capital firm founded by Mr. Hiro Mashita that invests in private equity and early-stage companies in South Asia. The team is privileged to have partnered with leading companies like Cashify, Ninjacart, Innerchef and BetterButter amongst others.</p>
    </Half>
  </PartnerWrapper>
);
